import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const COLLECTIONS_FINANCIAL_EFFICIENCY_FILTERS = REPORTS_DEFAULT_FILTERS

export const COLLECTIONS_FINANCIAL_EFFICIENCY_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'currency' | 'percent'
}> = [
  {
    id: 'collections',
    title: 'Collections',
    footer: 'Total collected revenue',
    format: 'currency',
  },
  {
    id: 'production',
    title: 'Production',
    footer: 'Production reference',
    format: 'currency',
  },
  {
    id: 'net-collection-percentage',
    title: 'Net Collection Percentage',
    footer: 'Collections divided by production',
    format: 'percent',
  },
  {
    id: 'same-day-payments',
    title: 'Same-day Payments',
    footer: 'Collected same visit',
    format: 'currency',
  },
]
